module.exports = __webpack_public_path__ + "static/img/banner-tools.70d36db5.png";